import dayjs from 'dayjs';

import { isValidDateString } from '@/utils/isValidDateString';

/**
 * Formats a date string according to the user's preferred format.
 * Returns the original string if it's not a valid date.
 * Returns an empty string if the input is empty/undefined.
 */
export function formatFactsheetDate(dateString: string | undefined, dateFormat: string): string {
  if (!dateString) {
    return '';
  }

  if (isValidDateString(dateString)) {
    return dayjs(dateString).format(dateFormat.toUpperCase());
  }

  return dateString;
}

/**
 * Formats a date string with a fallback value for empty dates.
 */
export function formatFactsheetDateWithFallback(
  dateString: string | undefined,
  dateFormat: string,
  fallback: string
): string {
  if (!dateString || dateString.length === 0) {
    return fallback;
  }
  return formatFactsheetDate(dateString, dateFormat);
}
